import { IPublishRulesEntry } from 'APIPackage/PublishRulesModule/interfaces/IPublishRulesEntry';
import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { IKnmReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';

export const makeUnplannedValues = (
  values: IPublishRulesEntry,
  statusesSelectOptions: IKnmStatusSelectOption[],
  reasonTypesSelectOptions: IKnmReasonTypeSelectOption[],
) => ({
  uponAttainingStatus: statusesSelectOptions?.filter(item =>
    values?.settings?.mainRule?.passportStatusCodes?.includes(item.code),
  ),
  publishDeadline:
    getPublishDeadlineOptions().find(item => item.id === values?.settings?.mainRule?.publicationMode) || undefined,
  additionalSettings:
    values?.settings?.additionalRules?.map(rule => ({
      typeOfBasis: reasonTypesSelectOptions?.find(item => item.id === rule.reasonTypeId),
      uponAttainingStatus: statusesSelectOptions.filter(item => rule?.rule?.passportStatusCodes?.includes(item.code)),
      publishDeadline: getPublishDeadlineOptions().find(item => item.id === rule?.rule?.publicationMode) || undefined,
    })) || [],
});
